import { render } from "./SiteNav.vue?vue&type=template&id=ed5de88c&scoped=true&ts=true"
import script from "./SiteNav.vue?vue&type=script&lang=ts"
export * from "./SiteNav.vue?vue&type=script&lang=ts"

import "./SiteNav.vue?vue&type=style&index=0&id=ed5de88c&scoped=true&lang=css"

import exportComponent from "/tmp/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed5de88c"]])

export default __exports__